import './header.scss'
import { hotModuleReload } from '../../../components/common/utilities/hot-module-reload'

hotModuleReload()
